import React from 'react'
import {Grid, GridProps} from '@mui/material';
import {Brightness3, Brightness5} from '@mui/icons-material';
import {BookingCardLabel, BookingCardValue} from './styles';

interface BookingCardRowProps extends Omit<GridProps, 'onClick'> {
  label: string;
  value: string;
  onClick?: (data: any, listId: string) => void;
  listId: string;
  data: any;
  cols?: number;
}

/**
 * A component for displaying a single row in a booking card with label and value.
 * @param label {string} The label text to display
 * @param value {string} The value text to display
 * @param onClick {function} Optional click handler for the row
 * @param listId {string} The ID of the list
 * @param data {any} Additional data associated with the row
 * @param cols {number} Number of columns to span (default: 1)
 * @param props Additional GridProps to pass to the Grid item
 * @deprecated
 */
const BookingCardRow = ({
  label,
  value,
  onClick,
  listId,
  data,
  cols = 1,
  ...props
}: BookingCardRowProps) => {
  const handleClick = () => {
     onClick && onClick(data, listId);
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case 'Approved':
      case 'Approved-Adjusted':
        return 'success';
      case 'Processing-ACH-Payment':
      case 'Processing-ACH-Payment-Adjusted':
      case 'Processing-ACH-Refund-Adjusted':
        return 'info';
      case 'Pending':
      case 'Pending-Verification Required':
      case 'Incomplete':
        return 'warning';
      default:
        return 'error';
    }
  };

  const AMPMIcon = () => {
    if(label.toLocaleLowerCase() === "start date" || (label.toLocaleLowerCase() === "end date" && value.toLocaleLowerCase() !== "until cancelled")) {
      const time = new Date(value);
      if (time.getHours() >= 6 && time.getHours() < 18) {
        return <Brightness5/>
      } else {
        return <Brightness3/>
      }
    }
  }

  const isLink = !!onClick;
  const isOverage = label.toLocaleLowerCase() === 'past due overages';
  const severity = label.toLocaleLowerCase() === 'status' ? getStatusClass(value) : undefined;

  return (
    <Grid item xs={12} sm={Math.min(12, 6 * cols)} md={Math.min(12, 3 * cols)} {...props}>
      <BookingCardLabel variant="body1">
        {label}
      </BookingCardLabel>
      <BookingCardValue variant="body1" severity={severity} link={isLink} overagesCount={isOverage} onClick={handleClick}>
        {value}
        <AMPMIcon/>
      </BookingCardValue>
    </Grid>
  );
};

export default BookingCardRow
